@if (
  {
    row: columnData | async,
    aData: additionData | async,
  };
  as $
) {
  <span class="cursor-pointer text-primary" (click)="OpenTrialHistory($.row)"
    >{{ $.row[$.aData.used_key] }} of {{ $.row[$.aData.total_key] }}</span
  >
}
